import { combineReducers } from 'redux';
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import commonReducer from "../services/common/reducer";
import patientReducer from "../services/patient/reducer";
import facilityReducer from "../services/facility/reducer";
import adminReducer from "../services/admin/reducer";
import employeeReducer from "../services/employee/reducer"

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  blacklist: ['auth']
}

const rootReducer = combineReducers({
  commonReducer,
  patientReducer,
  facilityReducer,
  adminReducer,
  employeeReducer
});
const persistedReducer = persistReducer(persistConfig, rootReducer)

export default persistedReducer;



